import { Component, Inject, QueryList } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BaseViewComponent } from '@sb/library/base';
import { ChipButtonSelectItemComponent } from '../item/chip-button-select-item.component';

@Component({
    selector: 'lib-chip-button-select-bottom-sheet',
    templateUrl: './chip-button-select-bottom-sheet.component.html',
    styleUrls: ['./chip-button-select-bottom-sheet.component.scss'],
})
export class ChipButtonSelectBottomSheetComponent<T> extends BaseViewComponent {

    constructor(private _MatBottomSheetRef: MatBottomSheetRef<ChipButtonSelectBottomSheetComponent<T>>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public options: QueryList<ChipButtonSelectItemComponent<T>>) {
        super();
    }

    SelectOption(option: ChipButtonSelectItemComponent<T>) {
        this._MatBottomSheetRef.dismiss(option);
    }
}
